export const environment = {
  production: false,
  apiProjectUrl: "https://a314-projects-dev.sc.avwaveinteractive.com/projects",
  apiUrlAdmin:
    "https://a314-admin-users-dev.sc.avwaveinteractive.com/admin-users",
  apiGoogleStorage:
    "https://a314-google-storage-dev.sc.avwaveinteractive.com/storage",
  urlStorage: "https://storage.googleapis.com/sc-avwave-dev/",
  testUser: {
    // tslint:disable-line
    token: "cualquiercosa",
    email: "user@user.user",
  },
};